import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import Navbar from './components/common/Navbar';
import Footer from './components/common/Footer';
import ScrollToTopOnMount from './components/common/ScrollToTopOnMount';
import ScrollManager from './components/common/ScrollManager';
import Home from './pages/Home';
import About from './pages/About';
import Purpose from './pages/Purpose';
import OurApproach from './pages/OurApproach';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import WhoWeWorkWith from './pages/WhoWeWorkWith';
import Cosmos from './pages/Cosmos';

import Contact from './pages/Contact';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminMessages from './pages/admin/AdminMessages';
import AdminServices from './pages/admin/AdminServices';

import AdminTestimonials from './pages/admin/AdminTestimonials';
import AdminPartners from './pages/admin/AdminPartners';
import AdminSettings from './pages/admin/AdminSettings';
import AdminQuestions from './pages/admin/AdminQuestions';
import AdminVersions from './pages/admin/AdminVersions';
import AdminAuditLogs from './pages/admin/AdminAuditLogs';
import AdminLayout from './components/admin/AdminLayout';
import ProtectedRoute from './components/common/ProtectedRoute';
import TrilogyAssessment from './pages/TrilogyAssessment';
import TrilogyResults from './pages/TrilogyResults';
import NotFound from './pages/NotFound';
import './styles/global.css';
import './styles/responsive.css';

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
      mirror: true,
      easing: 'ease-in-out',
      offset: 100
    });
  }, []);

  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <ScrollToTopOnMount />
          <ScrollManager />
          <div className="App">
            <Routes>
              {/* Public Routes with Navbar & Footer */}
              <Route path="/" element={
                <>
                  <Navbar />
                  <main><Home /></main>
                  <Footer />
                </>
              } />
              <Route path="/about" element={
                <>
                  <Navbar />
                  <main><About /></main>
                  <Footer />
                </>
              } />
              <Route path="/purpose" element={
                <>
                  <Navbar />
                  <main><Purpose /></main>
                  <Footer />
                </>
              } />
              <Route path="/our-approach" element={
                <>
                  <Navbar />
                  <main><OurApproach /></main>
                  <Footer />
                </>
              } />
              <Route path="/cosmos" element={
                <>
                  <Navbar />
                  <main><Cosmos /></main>
                  <Footer />
                </>
              } />
              <Route path="/services" element={
                <>
                  <Navbar />
                  <main><Services /></main>
                  <Footer />
                </>
              } />
              <Route path="/services/:serviceId" element={
                <>
                  <Navbar />
                  <main><ServiceDetail /></main>
                  <Footer />
                </>
              } />
              <Route path="/who-we-work-with" element={
                <>
                  <Navbar />
                  <main><WhoWeWorkWith /></main>
                  <Footer />
                </>
              } />

              <Route path="/contact" element={
                <>
                  <Navbar />
                  <main><Contact /></main>
                  <Footer />
                </>
              } />

              {/* Trilogy Assessment (Public) */}
              <Route path="/trilogy-assessment" element={
                <>
                  <Navbar />
                  <main><TrilogyAssessment /></main>
                  <Footer />
                </>
              } />
              <Route path="/trilogy/results/:scanId" element={
                <>
                  <Navbar />
                  <main><TrilogyResults /></main>
                  <Footer />
                </>
              } />

              {/* Admin Login (No Layout) */}
              <Route path="/admin/login" element={<AdminLogin />} />

              {/* Admin Routes with Admin Layout - Protected */}
              <Route path="/admin" element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }>
                <Route index element={<AdminDashboard />} />
                <Route path="dashboard" element={<AdminDashboard />} />
                <Route path="messages" element={<AdminMessages />} />
                <Route path="services" element={<AdminServices />} />

                <Route path="testimonials" element={<AdminTestimonials />} />
                <Route path="partners" element={<AdminPartners />} />
                <Route path="questions" element={<AdminQuestions />} />
                <Route path="versions" element={<AdminVersions />} />
                <Route path="audit-logs" element={<AdminAuditLogs />} />
                <Route path="settings" element={<AdminSettings />} />
              </Route>

              {/* 404 Page */}
              <Route path="*" element={
                <>
                  <Navbar />
                  <main><NotFound /></main>
                  <Footer />
                </>
              } />
            </Routes>
          </div>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
